'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// https://www.kirupa.com/react/transferring_properties.htm
// http://stackoverflow.com/questions/36631761/when-should-i-add-redux-to-a-react-app
var Module1Extra2 = (_dec = (0, _reactRedux.connect)(function (state) {
  return { user: state.auth.user };
}), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Module1Extra2, _Component);

  function Module1Extra2() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Module1Extra2);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Module1Extra2.__proto__ || (0, _getPrototypeOf2.default)(Module1Extra2)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      title: 'Difficulties of healthy eating'
    }, _this.handleChange = function (str, event) {
      var obj = _this.state;
      obj[str] = event.target.value;
      _this.setState(obj);
    }, _this.handleComplete = function () {
      var obj = {};
      obj.isCompleted = true;
      _this.setState(obj);
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  /*
   * User types in something for what was
   * involved in the diet
   */


  /*
   * Handle when user finishes this module
   */


  (0, _createClass3.default)(Module1Extra2, [{
    key: 'render',
    value: function render() {
      var styles = require('../../Modules.scss');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: styles.activityPanel },
          _react2.default.createElement(
            'div',
            { className: styles.title },
            _react2.default.createElement(
              'h3',
              null,
              'Module 1'
            ),
            _react2.default.createElement(
              'h2',
              null,
              this.state.title
            )
          ),
          _react2.default.createElement(
            'h2',
            null,
            'Why is healthy eating difficult for children after cancer treatment?'
          ),
          _react2.default.createElement(
            'p',
            null,
            'For many children, it can lead to:'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Loss of appetite, nausea, vomiting or diarrhoea'
          ),
          _react2.default.createElement(
            'p',
            null,
            'When children are on chemo and feeling sick, plain foods (e.g. chips, bread and pasta) are easier for children to eat than fruits and vegies. If children are not eating enough, high calorie \u2018junk\u2019 foods may be the only foods they eat (e.g. chips, hamburger or pizza).'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Taste changes'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Cancer treatment can change a child\u2019s taste buds. Children may become more sensitive to sour or bitter tastes like those found in fruit and vegetables. This can make eating fruits or vegies unpleasant.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Food aversions'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Children can develop a very strong dislike for foods they ate during chemo, even though the food did not make them feel sick. Like food poisoning, children may remember feeling nauseous every time they taste or smell these foods.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Parenting'
          ),
          _react2.default.createElement(
            'p',
            null,
            'When children are on chemo and feeling sick, parents may become less strict about their child\u2019s eating habits. Parents often have difficulty getting their child to eat anything other than \u2018junk food\u2019 while they are in hospital. If children are in pain or feeling sick, saying \u2018no\u2019 to a child who is asking for \u2018junk food\u2019 can also be difficult.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Steroids'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Children often take steroids as part of their cancer treatment, which makes them feel hungry all the time and crave foods which are high in salt and fat.'
          ),
          _react2.default.createElement(
            'h3',
            null,
            'Limited exposure to new foods'
          ),
          _react2.default.createElement(
            'p',
            null,
            'Children often need to taste a new or unpopular food (e.g. vegies) 10 or more times before they will accept it. Early exposure is important because most of our food likes and dislikes develop during childhood. These likes and dislikes can last a lifetime.'
          ),
          _react2.default.createElement(
            'p',
            null,
            'In hospital, children are often not able to eat with the family. If children do not see others eating and enjoying new foods (e.g. vegies), it can be very difficult to encourage them to taste them.'
          )
        )
      );
    }
  }]);
  return Module1Extra2;
}(_react.Component), _class2.propTypes = {
  user: _propTypes2.default.object
}, _temp2)) || _class);
exports.default = Module1Extra2;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Modules/0/Extra/Extra2.js
// module id = 1159
// module chunks = 0